import React from 'react';
import IconComponent from 'ui/src/components/Icon';
import AlertIcon from 'ui/src/icons/DS/_Alert';

interface PreviewPostErrorProps {
  message: string;
}

export default function PreviewPostError({ message }: PreviewPostErrorProps) {
  return (
    <div className="mb-5 flex items-center rounded bg-red-800 p-3">
      <IconComponent
        Icon={AlertIcon}
        size="IconL"
        options={{ className: 'fill-red-200 mr-2', viewBox: '0 0 20 20' }}
      />
      <p className="text-red-200">This post is not going to be generated properly: {message}</p>
    </div>
  );
}
